/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Tabs_Changelog1Inputs */

const id_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan perubahan`)
};

const ms_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log perubahan`)
};

const da_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringslog`)
};

const de_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsprotokoll`)
};

const en_us2_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const es_es2_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const es_mx2_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const fil_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talaan ng Pagbabago`)
};

const fr_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal`)
};

const it_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro modifiche`)
};

const hu_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változásnapló`)
};

const nl_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingslogboek`)
};

const no_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringslogg`)
};

const pl_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziennik zmian`)
};

const pt_br2_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de alterações`)
};

const pt_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registo de alterações`)
};

const ro_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurnal modificări`)
};

const fi_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutosloki`)
};

const sv_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringslogg`)
};

const vi_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký thay đổi`)
};

const tr_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişiklik Günlüğü`)
};

const cs_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam změn`)
};

const bg_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дневник на промените`)
};

const ru_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал изменений`)
};

const uk_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журнал змін`)
};

const ar_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل التغييرات`)
};

const hi_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव लॉग`)
};

const th_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกการเปลี่ยนแปลง`)
};

const ja_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新履歴`)
};

const zh_cn2_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日志`)
};

const zh_hant1_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日誌`)
};

const ko_offerdetail_tabs_changelog1 = /** @type {(inputs: Offerdetail_Tabs_Changelog1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변경 내역`)
};

/**
* | output |
* | --- |
* | "Changelog" |
*
* @param {Offerdetail_Tabs_Changelog1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_tabs_changelog1 = /** @type {((inputs?: Offerdetail_Tabs_Changelog1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Tabs_Changelog1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_tabs_changelog1(inputs)
	if (locale === "ms") return ms_offerdetail_tabs_changelog1(inputs)
	if (locale === "da") return da_offerdetail_tabs_changelog1(inputs)
	if (locale === "de") return de_offerdetail_tabs_changelog1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_tabs_changelog1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_tabs_changelog1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_tabs_changelog1(inputs)
	if (locale === "fil") return fil_offerdetail_tabs_changelog1(inputs)
	if (locale === "fr") return fr_offerdetail_tabs_changelog1(inputs)
	if (locale === "it") return it_offerdetail_tabs_changelog1(inputs)
	if (locale === "hu") return hu_offerdetail_tabs_changelog1(inputs)
	if (locale === "nl") return nl_offerdetail_tabs_changelog1(inputs)
	if (locale === "no") return no_offerdetail_tabs_changelog1(inputs)
	if (locale === "pl") return pl_offerdetail_tabs_changelog1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_tabs_changelog1(inputs)
	if (locale === "pt") return pt_offerdetail_tabs_changelog1(inputs)
	if (locale === "ro") return ro_offerdetail_tabs_changelog1(inputs)
	if (locale === "fi") return fi_offerdetail_tabs_changelog1(inputs)
	if (locale === "sv") return sv_offerdetail_tabs_changelog1(inputs)
	if (locale === "vi") return vi_offerdetail_tabs_changelog1(inputs)
	if (locale === "tr") return tr_offerdetail_tabs_changelog1(inputs)
	if (locale === "cs") return cs_offerdetail_tabs_changelog1(inputs)
	if (locale === "bg") return bg_offerdetail_tabs_changelog1(inputs)
	if (locale === "ru") return ru_offerdetail_tabs_changelog1(inputs)
	if (locale === "uk") return uk_offerdetail_tabs_changelog1(inputs)
	if (locale === "ar") return ar_offerdetail_tabs_changelog1(inputs)
	if (locale === "hi") return hi_offerdetail_tabs_changelog1(inputs)
	if (locale === "th") return th_offerdetail_tabs_changelog1(inputs)
	if (locale === "ja") return ja_offerdetail_tabs_changelog1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_tabs_changelog1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_tabs_changelog1(inputs)
	return ko_offerdetail_tabs_changelog1(inputs)
});
export { offerdetail_tabs_changelog1 as "offerDetail.tabs.changelog" }